
import React from 'react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from 'lucide-react';
import ContactDialog from './ContactDialog';

const WhySparkwaveAI: React.FC = () => {
  const benefits = [
    {
      title: "AI Strategy & Innovation",
      description: "We help you identify where AI can create the most value for your business."
    },
    {
      title: "Fast Implementation",
      description: "Get AI solutions running in weeks, not years."
    },
    {
      title: "Measurable ROI",
      description: "AI that delivers clear business results and tangible value."
    },
    {
      title: "Full-Stack Development",
      description: "From concept to deployment, we build complete AI solutions."
    }
  ];

  return (
    <section id="why-us" className="py-20 px-6 md:px-10 bg-gray-800 text-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-heading-accent/20 text-heading-accent mb-4 animate-fade-in">
            <span className="text-sm font-medium">Why Sparkwave AI?</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fade-in">
            AI That Works. <span className="text-gradient">Business That Grows.</span>
          </h2>
          <p className="text-lg text-white/80 mb-8 animate-fade-in delay-200 max-w-3xl mx-auto">
            We take a practical approach to AI implementation – focused on business results, speed, and measurable impact.
          </p>
          
          <div className="animate-fade-in delay-400 mb-16">
            <ContactDialog 
              trigger={
                <Button size="lg" className="btn-hover-effect group bg-heading-accent hover:bg-heading-accent/90 text-white">
                  Book a Discovery Call
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              }
            />
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <Card 
              key={index} 
              className="p-6 bg-gray-900/90 border-gray-600 backdrop-blur-sm card-hover animate-fade-in-right"
              style={{ animationDelay: `${index * 100 + 200}ms` }}
            >
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <div className="p-1.5 rounded-full bg-heading-accent/20 text-heading-accent">
                    <Check className="h-4 w-4" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-white">{benefit.title}</h3>
                  <p className="text-white/80 text-sm">{benefit.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySparkwaveAI;
